export default {
  'releaseBillToPay.list.header.code': 'Code',
  'releaseBillToPay.list.header.installmentTag': 'Tag',
  'releaseBillToPay.list.header.companies': 'Company',
  'releaseBillToPay.list.header.documentNumber': 'Document Number',
  'releaseBillToPay.list.header.creditor': 'Creditor',
  'releaseBillToPay.list.header.description': 'Description',
  'releaseBillToPay.list.header.documentType': 'Doc. Type',
  'releaseBillToPay.list.header.dueDate': 'Due Date',
  'releaseBillToPay.list.header.situation': 'Situation',
  'releaseBillToPay.list.header.value': 'Value',
  'releaseBillToPay.list.header.actions': 'Action',

  'releaseBillToPay.domain.enums.situation_installment_payable.open': 'Open',
  'releaseBillToPay.domain.enums.situation_installment_payable.settled':
    'Settled',

  'releaseBillToPay.searchBar.create': 'Create New Account Payable',
  'releaseBillToPay.searchBar.settleMultipleInstallments':
    'Settle Selected Installments',

  'release.form.company': 'Company',
  'release.form.creditor': 'Creditor',
  'release.form.supplier': 'Supplier',
  'release.form.employee': 'Employee',
  'release.form.planAccount': 'Plan Account',
  'release.form.description': 'Description',
  'release.form.documentNumber': 'Document Number',
  'release.form.split': 'Split',
  'release.form.taxes': 'Taxes',
  'release.form.documentType': 'Document Type',
  'release.form.issueDate': 'Issue Date',
  'release.form.dueDate': 'Due Date',
  'release.form.payDay': 'Payday',
  'release.form.costCenter': 'Cost Center',
  'release.form.bankAccount': 'Bank Account',
  'release.form.value': '(US$) Value',
  'release.form.increaseAndDecrease': '(US$) Incr./Decr.',
  'release.form.supplierCredit': 'Supplier Credit',
  'release.form.netValue': '(US$) Net Value',
  'release.form.installmentBasis': 'Base amount of the installment',
  'release.form.observation': 'Observation',

  'release.form.button.renegotiate': 'Renegotiate',
  'release.form.button.settleInstallment': 'Settle installment',
  'release.form.button.partiallySettle': 'Partially settle',
  'release.form.button.generateTicket': 'Generate ticket',

  'release.modal.form.taxationData': 'Taxation Data',
  'release.modal.form.noteData': 'Note Data',
  'release.modal.form.series': 'Series',
  'release.modal.form.model': 'Model',
  'release.modal.form.cfop': 'Cfop',
  'release.modal.form.amount': 'Amount',
  'release.modal.form.icms': 'ICMS',
  'release.modal.form.icmsAliquot': 'ICMS Aliquot',
  'release.modal.form.icmsValue': 'ICMS Value',
  'release.modal.form.pis': 'PIS',
  'release.modal.form.pisAliquot': 'PIS Aliquot',
  'release.modal.form.pisValue': 'PIS Value',
  'release.modal.form.cofins': 'COFINS',
  'release.modal.form.cofinsAliquot': 'COFINS Aliq.',
  'release.modal.form.cofinsValue': 'COFINS Value',
};
